import superagentPromisePlugin from 'superagent-promise-plugin'
import http_agent from './http_agent'
import http_request from './http_request'

import config from 'config'

function _genericCatch() {
	return {
		error_code: -1,
		payload: {
			message: 'Something went wrong. Please try again later.',
		},
	}
}

function getLibraryLessons(entityUID, folder_id, page, order_field, order_type, search, filters, limit = '', child_id) {
	const path = config.services + 'privateLibrary/getEntities'
	return http_agent.post(path)
		.send({
			entityUID,
			folder_id,
			page,
			order_field,
			order_type,
			search,
			filters: filters?filters.join(','):'',
			limit,
			child_id,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function getLibrarySettings(id) {
	return http_agent.post(config.services + 'privateLibrary/getSettings')
		.send({
			id,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function getLibraryFolders(privateLibraryId, parentId) {
	return http_agent.post(config.services + 'userCategories/all')
		.send({
			privateLibraryId,
			parentId,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function saveSettings(entityUID, name, users_can_add) {
	return http_agent.post(config.services + 'privateLibrary/save')
		.send({
			entityUID,
			name,
			users_can_add,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function getFilterDefinitions(privateLibraryId) {
	return http_agent.post(config.services + 'privateLibrary/getFilters')
		.send({
			entityUID: privateLibraryId,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function searchLibraryLessons(entityUID, page, order_field, order_type, search, filters, limit = '') {
	const path = config.services + 'privateLibrary/searchEntities'
	return http_agent.post(path)
		.send({
			entityUID,
			page,
			order_field,
			order_type,
			search,
			filters: filters.join(','),
			limit,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function searchSaveEntities(entityUID, folder_id, all_entities, lessons, bundles, order_field, order_type, search, filters) {
	const path = config.services + 'privateLibrary/saveEntities'
	const params = {
		entityUID,
		folder_id,
	}
	if (all_entities) {
		params.all_entities = 1
		params.search = search
		params.filters = filters.join(',')
		params.order_type = order_type
		params.order_field = order_field
	} else {
		lessons = lessons || []
		bundles = bundles || []
		params.all_entities = 0,
		params.lesson_ids = lessons.join(',')
		params.bundle_ids = bundles.join(',')
	}
	return http_agent.post(path)
		.send(params)
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function updateFolder(libraryUID, folderUID, name, productUid, productType, color, parentId) {
	const params = {
		privateLibraryId: libraryUID,
		entityUID: folderUID,
	}
	if (name) {
		params.name = name
	}
	if (productUid) {
		params.productUid = productUid
		params.productType = productType
	}
	if (color) {
		params.color = color
	}
	if (parentId) {
		params.parentId = parentId
	}
	return http_request.post(config.services + 'userCategories/save')
		.send(params)
}

function saveLessonsToFolder(folder_id, lessons, bundles, private_library_id) {
	return http_request.post(config.services + 'privateLibraryFolder/saveEntities')
		.send({
			folder_id,
			bundle_ids: bundles.join(','),
			lesson_ids: lessons.join(','),
			private_library_id,
		})
}

function removeEntityFromFolder(entityUID, entityType, folder_id) {
	return http_agent.post(config.services + 'privateLibraryFolder/removeEntity')
		.send({
			folder_id,
			entityUID,
			entityType: entityType === '1' ? 'Presentation':'Bundle',
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
}

function deleteFolder(libraryUID, folderUID) {
	return http_agent.post(config.services + 'userCategories/delete')
		.send({
			privateLibraryId: libraryUID,
			entityUID: folderUID,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function deleteLesson(id, entityUID, entityType) {
	return http_agent.post(config.services + 'privateLibrary/deleteEntity')
		.send({
			id,
			entityUID,
			entityType: entityType === '1' ? 'Presentation' : 'Bundle',
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function getLessonMetrics(entityUID, session_uid, extra) {
	const post_data = {
		entityUID,
	}
	if (session_uid) {
		post_data.session_uid = session_uid
	}
	if (extra) {
		post_data.extra = extra
	}
	return http_request.post(config.ct + 'service/presentation/metrics')
		.send(post_data)
}

// code repeated on my_library_sync and store_sync
function launchSession(presentation_uid, isNew, jwt, sessionType) {
	const headers = {}
	if (jwt) {
		headers.jwt = jwt
	}

	return http_request.post(config.hub + 'session/start')
		.withHeaders(headers)
		.send({
			device_type: 'ipad',
			presentation_uid,
			device_uid: 'tabc',
			session_uid: '',
			new: isNew,
			session_type: sessionType,
		})
}

export default {
	getLibraryLessons,
	getLibrarySettings,
	getLibraryFolders,
	saveSettings,
	getFilterDefinitions,
	searchLibraryLessons,
	searchSaveEntities,
	updateFolder,
	deleteFolder,
	saveLessonsToFolder,
	removeEntityFromFolder,
	deleteLesson,
	getLessonMetrics,
	launchSession,
}
